import * as Common from "../Common/modules";
import { IBanner } from "../Models/Banner/Banner";

export interface IBannerApiClient {
    getActiveGeneralBanners: () => ng.IPromise<IBanner[]>;
    getActiveCustomerBanners: (igsCustomerNumber: string) => ng.IPromise<IBanner[]>;
}

export class BannerApiClient implements IBannerApiClient {
    public static $inject = ["igs.apiClientService"];

    public prefix: string;

    constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
        this.prefix = "Banners";
    }

    public getActiveGeneralBanners = (): ng.IPromise<IBanner[]> => {
        const url = `${this.prefix}?code=GENERAL&active=true`;
        return this.igsApiClientService.get(url);
    }

    public getActiveCustomerBanners = (igsCustomerNumber: string): ng.IPromise<IBanner[]> => {
        const url = `/Customer/${igsCustomerNumber}/Banners?active=true`;
        return this.igsApiClientService.get(url);
    }
}
